import { render } from "./TaskAnalysisTarget.vue?vue&type=template&id=1cf2a61e&scoped=true"
import script from "./TaskAnalysisTarget.vue?vue&type=script&lang=js"
export * from "./TaskAnalysisTarget.vue?vue&type=script&lang=js"

import "./TaskAnalysisTarget.vue?vue&type=style&index=0&id=1cf2a61e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf2a61e"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
